import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M22.656 25.034c-1.286 1.263-2.705 1.066-4.058.47-1.438-.607-2.753-.646-4.272 0-1.891.826-2.895.586-4.034-.47C3.86 18.332 4.81 8.124 12.119 7.74c1.773.096 3.014.992 4.058 1.067 1.552-.32 3.038-1.235 4.7-1.115q2.991.245 4.485 2.395c-4.106 2.498-3.133 7.974.638 9.511-.755 2.006-1.723 3.987-3.346 5.452zM16.035 7.668C15.843 4.69 18.228 2.24 20.97 2c.378 3.435-3.085 6.005-4.936 5.668"
    }
  )
);
var SvgAppleFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var AppleFilled_default = SvgAppleFilled;

export { AppleFilled_default as default };
